var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.isMobile)?_c('iframe',{attrs:{"src":_vm.getAdIframeSrc(),"frameborder":"0","scrolling":"no","width":"410","height":"100"}}):_vm._e(),_vm._v(" "),(_vm.isMobile)?_c('iframe',{attrs:{"src":_vm.getAdIframeSrc(),"frameborder":"0","scrolling":"no","width":"320","height":"100"}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }